import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
// import { currencyFormat } from "../../utils/currencyFormater";
import moment from "moment";
import DataTableExtensions from "react-data-table-component-extensions";
import { RustyRoyalCoin } from "../../utils/SvgIcons";

const TransactionHistoryTable = ({ myData }) => {
  const columns = [
    {
      name: "Transaction ID",
      selector: (row) => row.transactionId || "N/A",
      sortable: true,
    },
    {
      name: "User ID",
      selector: (row) => row?.userId?._id || "N/A",
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row?.userId?.username || "N/A",
      sortable: true,
    },
    {
      name: "Crypto Amount",
      selector: (row) => row.cryptoAmt || "N/A",
      sortable: true,
    },
    {
      name: "Amount (USD)",
      // cell: (row) => currencyFormat(row.amountInUsd),
      cell: (row) => (
        <p className="d-flex m-0" style={{}}>
          <RustyRoyalCoin size={16} />{" "}
          <div className="pl-1">{row.amountInUsd}</div>
        </p>
      ),
      sortable: true,
    },
    {
      name: "Payment Method",
      selector: (row) => row.payment || "N/A",
      sortable: true,
    },
    {
      name: "Transaction Type",
      selector: (row) => row.type || "N/A",
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={
            row.status === "completed" ? "text-success" : "text-warning"
          }
        >
          {row.status}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Wallet Address",
      selector: (row) => row.payAddress || "N/A",
    },
    {
      name: "Transaction Date",
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
  ];

  return (
    <div>
      {/* <DeleteConfirmForSelected />
      {role?.some((r) => ['suUsers', 'superAdmin', 'delUsers'].includes(r)) && (
        <div className='btn-popup pull-right'>
          <span className='btn btn-secondary del-btn'>Delete</span>
        </div>
      )} */}

      <Fragment>
        <DataTableExtensions
          columns={columns}
          data={myData}
          print={false}
          export={false}
        >
          <DataTable
            data={myData}
            columns={columns}
            pagination
            striped={true}
            center={true}
            selectableRows
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

export default TransactionHistoryTable;
